import { type UserAvatarProps, UserAvatar } from '@shared/components';
import { isInternalEmailDomain } from '@shared/utils';
import { useConfig } from '@user-management/configuration';

type UserTypeAvatarProps = Omit<UserAvatarProps, 'primary'> & { email: string };

export default function UserTypeAvatar(props: Readonly<UserTypeAvatarProps>) {
  const { email, ...restProps } = props;
  const configuration = useConfig();

  const internalUserEmailDomains = configuration.userManagement.internalUserEmailDomains;
  const isPrimary = isInternalEmailDomain(email, internalUserEmailDomains);

  return <UserAvatar variant='circular' primary={isPrimary} {...restProps} />;
}
